import { EventEmitter } from '@angular/core';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { OrderHistoryLine } from '../../models/orderhistoryline';
var OrderhistorylinesLineComponent = /** @class */ (function () {
    function OrderhistorylinesLineComponent(analyticsSvc) {
        this.analyticsSvc = analyticsSvc;
        this.onReOrder = new EventEmitter();
    }
    Object.defineProperty(OrderhistorylinesLineComponent.prototype, "hasDesc", {
        get: function () {
            return !!this.line.productDesc;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderhistorylinesLineComponent.prototype, "relativeQuantity", {
        get: function () {
            return this.line.quantity / this.line.stepping;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderhistorylinesLineComponent.prototype, "absoluteQuantity", {
        get: function () {
            return this.line.quantity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderhistorylinesLineComponent.prototype, "thumbnail", {
        get: function () {
            var thumb = this.line.productImgs.find(function (img) { return img.type === 'thumb'; });
            if (thumb && thumb.src) {
                return thumb.src;
            }
            // No thumb, return default no-image-placeholder
            return '/assets/images/no-image-placeholder.png';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderhistorylinesLineComponent.prototype, "isProductOrderable", {
        get: function () {
            return this.isReOrderable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderhistorylinesLineComponent.prototype, "productId", {
        get: function () {
            return this.line.currentProduct.length > 0
                ? this.line.currentProduct[0]._id
                : '';
        },
        enumerable: true,
        configurable: true
    });
    OrderhistorylinesLineComponent.prototype.reOrder = function () {
        this.analyticsSvc.event('click', { event_category: 'Orderhistory', event_label: 'Re-Order' });
        this.onReOrder.emit(this.productId);
    };
    return OrderhistorylinesLineComponent;
}());
export { OrderhistorylinesLineComponent };
